import React from 'react';
import classNames from 'classnames';
import FileActivity from './components/FileActivity';
import RankedMembers from './components/RankedMembers';
import QAndAChart from 'router/subrouters/DataRoom/components/QAndAChart';

import './Overview.styles.scss';
import './Overview.styles.responsive.scss';

type OverviewProps = {
  className?: string;
};

const Overview: React.FC<OverviewProps> = (props) => {
  const { className } = props;

  const classes = classNames('overview', className);

  return (
    <div className={classes}>
      <RankedMembers className="card-wrapper" />
      <FileActivity className="card-wrapper" />
      <QAndAChart className="card-wrapper" />
    </div>
  );
};

export default Overview;
